
<template>
    <section class="banner-outer" style="text-align: center;">
        <div class="col-sm-12 col-md-12">
            <img src="https://img.hogonmr.cn/news-top.png?imageView2/0/w/1500" alt="">
        </div>
    </section>
<!--    <div class="inner-header" style="background: rgba(0, 0, 0, 0) url(https://img.hogonmr.cn/news-top.png?imageView2/0/w/1500) no-repeat scroll 0 0 / cover;padding-bottom: 170px;">-->
<!--        <h2></h2>-->
<!--    </div>-->
    <section class="blog">
        <div class="container">

            <div class="col-sm-12">
                <div class="masonry masonry-columns-3">
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news1.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">HOGON MR 意大利米兰专卖店成立</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>HOGON MR 1990年起源于意大利，创始人霍根先生随性别致的独特理念是对时尚生活方式的完美诠释。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news4.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">HOGON MR ·中国广州品牌旗舰店…</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2013年，中国广州荔湾区1000平米的HOGON MR品牌旗舰店正式开业，开业状况盛大空前。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news6.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">参加意大利米兰buybrand</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2021年9月，参加意大利米兰buybrand展，展会唯一中国品牌，并发布2021秋冬流行趋势。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news2.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">巴黎·HOGON MR第一家海外专卖店</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>1998年秋冬，巴黎第一家HOGON MR海外专卖店正式成立，标志着HOGON MR品牌全球扩张的第一步。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news7.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">印度尼西亚·HOGON MR 专卖店成立</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2020年7月，印度尼西亚sogo百货，开设4家HOGON MR专卖店。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news3.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">HOGON MR 中东·沙特专卖店成立</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2007年9月，沙特，第一家中东地区HOGON MR专卖店成立，继续细分国际市场。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news5.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">HOGON MR 参加德国DOSELDUF...</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2020年11月，HOGON MR品牌参加德国DOSELDUF时装展，并发布2021秋冬新品。</p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>
                    <div class="masonry-item">
                        <div class="blog-img">
                            <img class="img-responsive" src="https://img.hogonmr.cn/news/news8.png?imageView2/0/w/500" alt="sample image">
                            <div class="blog-img-hover"><a href="#"><i class="fa fa-paperclip" aria-hidden="true"></i></a></div>
                        </div>
                        <p class="hank"><a href="blog-details.html">HOGON MR 品牌正式入驻抖音</a></p>
                        <p class="time">来自 <span>azero</span> / 2019年12月</p>
                        <p>2021年12月 HOGON MR 品牌正式入驻抖音线上平台深受消费者追捧. </p>
                        <a href="#" class="readbtn">阅读更多</a>

                    </div>

                </div>
            </div>

        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
